import * as React from 'react';

function SvgEmail(props) {
  return (
    <svg width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.5 6.88v7.62h11V6.416l-4.42 3.663a1.75 1.75 0 01-2.154.061L4.5 6.88zm9.754-1.38H5.156l4.66 3.432a.25.25 0 00.307-.008L14.254 5.5zM3 5a1 1 0 011-1h12a1 1 0 011 1v10a1 1 0 01-1 1H4a1 1 0 01-1-1V5z"
        fill={props.color}
      />
    </svg>
  );
}

export default SvgEmail;
